import {
    ChangeDetectionStrategy,
    Component,
    Signal,
    ViewEncapsulation,
    booleanAttribute,
    computed,
    inject,
    input,
    model,
    signal,
} from '@angular/core';

export const DS_MODAL_VARIANT_ARRAY = ['surface-lowest', 'surface-low', 'surface'] as const;
export type DsModalVariant = (typeof DS_MODAL_VARIANT_ARRAY)[number];
export class DsModalContext {
    // eslint-disable-next-line @angular-eslint/prefer-signals
    public inverse: Signal<boolean> = signal(false); // Explicit type
}

@Component({
    selector: 'ds-modal',
    template: ` <ng-content />`,
    host: {
        'class': 'ds-modal',
        'role': 'dialog',
        'aria-label': 'Modal dialog',
        '[class.ds-modal-inverse]': 'inverse()',
        '[class.ds-modal-no-radius]': '!radius()',
        '[class.ds-modal-bottom-sheet]': 'bottomSheet()',
        '[class]': 'hostClass()',
        '[style.--bg-image]': 'backgroundImageUrl()',
        '[class.ds-modal-with-bg]': 'backgroundImage()',
    },
    providers: [DsModalContext],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    styleUrl: './modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsModal {
    public readonly inverse = input(false, { transform: booleanAttribute });
    public readonly bottomSheet = input(false, { transform: booleanAttribute });
    public readonly radius = model<boolean>(true);
    public readonly variant = model<DsModalVariant>('surface');
    public readonly backgroundImage = input<string>();

    private readonly context = inject(DsModalContext);

    protected readonly hostClass = computed(() => `ds-modal-${this.variant()}`);

    constructor() {
        this.context.inverse = computed(() => this.inverse());
    }

    private readonly _backgroundImageUrl = computed(() => {
        const bg = this.backgroundImage();
        return bg ? `url('${bg}')` : null;
    });

    backgroundImageUrl(): string | null {
        return this._backgroundImageUrl();
    }
}
